class MxTravelFooter extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.dataset.ready = 'true';
    this.track = this.querySelector('[data-country-track]');
    this.previousButton = this.querySelector('[data-country-previous]');
    this.nextButton = this.querySelector('[data-country-next]');

    this.querySelectorAll('[data-country-code]').forEach((flag) => {
      const countryCode = flag.dataset.countryCode?.toUpperCase();
      if (!countryCode || countryCode.length !== 2) return;

      flag.textContent = [...countryCode]
        .map((letter) => String.fromCodePoint(127397 + letter.charCodeAt(0)))
        .join('');
    });

    this.handlePrevious = () => this.moveSlider(-1);
    this.handleNext = () => this.moveSlider(1);
    this.handleTrackScroll = () => this.updateSliderButtons();
    this.handleTrackKeydown = (event) => {
      if (event.target !== this.track) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.moveSlider(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.moveSlider(1);
      }
    };

    this.previousButton?.addEventListener('click', this.handlePrevious);
    this.nextButton?.addEventListener('click', this.handleNext);
    this.track?.addEventListener('scroll', this.handleTrackScroll, { passive: true });
    this.track?.addEventListener('keydown', this.handleTrackKeydown);

    if (this.track && 'ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.updateSliderButtons());
      this.resizeObserver.observe(this.track);
    }

    this.updateSliderButtons();
  }

  disconnectedCallback() {
    this.previousButton?.removeEventListener('click', this.handlePrevious);
    this.nextButton?.removeEventListener('click', this.handleNext);
    this.track?.removeEventListener('scroll', this.handleTrackScroll);
    this.track?.removeEventListener('keydown', this.handleTrackKeydown);
    this.resizeObserver?.disconnect();
  }

  moveSlider(direction) {
    if (!this.track) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const distance = Math.max(this.track.clientWidth * 0.78, 280);

    this.track.scrollBy({
      left: distance * direction,
      behavior: reducedMotion ? 'auto' : 'smooth',
    });
  }

  updateSliderButtons() {
    if (!this.track) return;

    const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    const atStart = this.track.scrollLeft <= 2;
    const atEnd = this.track.scrollLeft >= maxScroll - 2;

    if (this.previousButton) this.previousButton.disabled = atStart;
    if (this.nextButton) this.nextButton.disabled = atEnd;
  }
}

if (!customElements.get('mx-travel-footer')) {
  customElements.define('mx-travel-footer', MxTravelFooter);
}
